import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faFolderBookmark, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { PulseButton } from 'src/components';

interface ColumnHeadersProps {
  allowMultiple?: boolean;
  onCreateNew?: () => void;
}

const ColumnHeaders: React.FC<ColumnHeadersProps> = ({
  allowMultiple = false,
  onCreateNew,
}) => {
  return (
    <div className={`h-12 px-4 border-b border-neutral-200 flex items-center gap-2 ${allowMultiple ? 'col-span-full' : ''}`}>
      <div className="w-5 h-5 flex items-center justify-center">
        <Icon
          icon={faFolderBookmark}
          className="w-4 h-3.5 text-neutral-600"
        />
      </div>
      <div className="flex-1 justify-start text-primary text-sm font-bold font-['Inter'] leading-tight">
        Code Sets
      </div>
      {onCreateNew && (
        <PulseButton
          variant="plain"
          color="primary"
          size="sm"
          startDecorator={faPlus}
          onClick={onCreateNew}
          aria-label="Create new code set"
          data-testid="analytics-selector-new-button"
        >
          New
        </PulseButton>
      )}
    </div>
  );
};

export default ColumnHeaders;
